<template>
  <main class="mypage-redesign">
    <!-- 헤더 영역 -->
    <header class="mypage-header">
      <div class="header-content">
        <div class="welcome-section">
          <h1 class="page-title">마이페이지</h1>
          <p class="welcome-text">
            <span class="user-name">{{ $store.state.uid.id }}</span
            >님, 반갑습니다
          </p>
        </div>
        <div class="header-actions">
          <!-- 모바일 햄버거 버튼 -->
          <button @click="toggleMobileMenu" class="mobile-menu-button md:hidden" aria-label="메뉴 열기">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>

          <VDialog no-scroll :classes="{ bg: 'bg-black-alpha' }">
            <template #toggle="{ bind, on }">
              <button v-bind="bind" v-on="on" class="action-btn primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M12.0808 4.10666C12.3083 3.87916 12.3083 3.49999 12.0808 3.28416L10.7158 1.91916C10.5 1.69166 10.1208 1.69166 9.89333 1.91916L8.82 2.98666L11.0075 5.17416M1.75 10.0625V12.25H3.9375L10.3892 5.79249L8.20167 3.60499L1.75 10.0625Z"
                    fill="currentColor"
                  />
                </svg>
                개인정보 수정
              </button>
            </template>

            <template #default="{ close }">
              <div class="bg-black bg-opacity-25 w-screen h-screen flex justify-center items-center">
                <div class="min-w-[25vw] flex flex-col bg-white w-fit rounded-3xl">
                  <button aria-label="close" class="my-dialog__close w-fit mt-3 mr-4 self-end" @click="close">
                    <h4 class="text-2xl">
                      <font-awesome-icon icon="fa-solid fa-circle-xmark" />
                    </h4>
                  </button>
                  <MemberProfilePage />
                </div>
              </div>
            </template>
          </VDialog>

          <button type="button" class="action-btn secondary" @click="logout()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
              <path
                d="M9.91699 4.08333L9.09449 4.90583L10.5995 6.41667H4.66699V7.58333H10.5995L9.09449 9.08833L9.91699 9.91667L12.8337 7M2.33366 2.91667H7.00033V1.75H2.33366C1.69199 1.75 1.16699 2.275 1.16699 2.91667V11.0833C1.16699 11.725 1.69199 12.25 2.33366 12.25H7.00033V11.0833H2.33366V2.91667Z"
                fill="currentColor"
              />
            </svg>
            로그아웃
          </button>
        </div>
      </div>
    </header>

    <!-- 모바일 메뉴 오버레이 -->
    <div v-if="isMobileMenuOpen" class="mobile-menu-overlay" @click="toggleMobileMenu">
      <aside class="mobile-sidebar" @click.stop role="navigation" aria-label="마이페이지 메뉴">
        <div class="mobile-sidebar-header">
          <h2 class="mobile-sidebar-title">메뉴</h2>
          <button @click="toggleMobileMenu" class="mobile-sidebar-close" aria-label="메뉴 닫기">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>

        <nav class="nav-section">
          <h3 class="nav-title" id="nav-section-1">접수·결제 정보</h3>
          <ul class="nav-list" role="list">
            <li>
              <router-link to="/profile/confList" target="_blank" class="nav-link" @click="toggleMobileMenu">
                <span class="nav-icon">📋</span>
                <span class="nav-text">
                  컨퍼런스 신청내역
                  <svg class="external-link-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333M9 1H13M13 1V5M13 1L5.66667 8.33333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/list" class="nav-link" @click="toggleMobileMenu">
                <span class="nav-icon">🛍️</span>
                주문내역
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/paymentList" class="nav-link" @click="toggleMobileMenu">
                <span class="nav-icon">💳</span>
                결제내역
              </router-link>
            </li>
          </ul>
        </nav>

        <nav class="nav-section">
          <h3 class="nav-title" id="nav-section-2">내 콘텐츠</h3>
          <ul class="nav-list" role="list">
            <li>
              <router-link to="/mypage/contentsBox" class="nav-link" @click="toggleMobileMenu">
                <span class="nav-icon">📦</span>
                콘텐츠 보관함
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/downloadHistory" class="nav-link" @click="toggleMobileMenu">
                <span class="nav-icon">⬇️</span>
                다운로드 내역
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/cart" target="_blank" class="nav-link" @click="toggleMobileMenu">
                <span class="nav-icon">🛒</span>
                <span class="nav-text">
                  장바구니
                  <svg class="external-link-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333M9 1H13M13 1V5M13 1L5.66667 8.33333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </router-link>
            </li>
          </ul>
        </nav>

        <nav class="nav-section">
          <h3 class="nav-title" id="nav-section-3">작성한 글 & 리뷰</h3>
          <ul class="nav-list" role="list">
            <li>
              <router-link to="/mypage/post" class="nav-link" @click="toggleMobileMenu">
                <span class="nav-icon">✍️</span>
                내가 작성한 글
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/review" class="nav-link" @click="toggleMobileMenu">
                <span class="nav-icon">⭐</span>
                나의 리뷰
              </router-link>
            </li>
          </ul>
        </nav>
      </aside>
    </div>

    <!-- 메인 콘텐츠 영역 -->
    <div class="mypage-container">
      <!-- 좌측 네비게이션 (데스크톱) -->
      <aside class="sidebar-nav" role="navigation" aria-label="마이페이지 메뉴">
        <div class="nav-section" aria-labelledby="nav-desktop-1">
          <h3 class="nav-title" id="nav-desktop-1">접수·결제 정보</h3>
          <ul class="nav-list" role="list">
            <li>
              <router-link to="/profile/confList" target="_blank" class="nav-link">
                <span class="nav-icon">📋</span>
                <span class="nav-text">
                  컨퍼런스 신청내역
                  <svg class="external-link-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333M9 1H13M13 1V5M13 1L5.66667 8.33333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/list" class="nav-link">
                <span class="nav-icon">🛍️</span>
                주문내역
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/paymentList" class="nav-link">
                <span class="nav-icon">💳</span>
                결제내역
              </router-link>
            </li>
          </ul>
        </div>

        <div class="nav-section" aria-labelledby="nav-desktop-2">
          <h3 class="nav-title" id="nav-desktop-2">내 콘텐츠</h3>
          <ul class="nav-list" role="list">
            <li>
              <router-link to="/mypage/contentsBox" class="nav-link">
                <span class="nav-icon">📦</span>
                콘텐츠 보관함
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/downloadHistory" class="nav-link">
                <span class="nav-icon">⬇️</span>
                다운로드 내역
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/cart" target="_blank" class="nav-link">
                <span class="nav-icon">🛒</span>
                <span class="nav-text">
                  장바구니
                  <svg class="external-link-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333M9 1H13M13 1V5M13 1L5.66667 8.33333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="nav-section" aria-labelledby="nav-desktop-3">
          <h3 class="nav-title" id="nav-desktop-3">작성한 글 & 리뷰</h3>
          <ul class="nav-list" role="list">
            <li>
              <router-link to="/mypage/post" class="nav-link">
                <span class="nav-icon">✍️</span>
                내가 작성한 글
              </router-link>
            </li>
            <li>
              <router-link to="/mypage/review" class="nav-link">
                <span class="nav-icon">⭐</span>
                나의 리뷰
              </router-link>
            </li>
          </ul>
        </div>
      </aside>

      <!-- 메인 콘텐츠 -->
      <div class="main-content">
        <!-- 하나 바이블 설정 -->
        <section class="bible-settings-section">
          <div class="section-header">
            <h2 class="section-title">하나 바이블 설정</h2>
            <p class="section-description">맞춤형 콘텐츠 추천을 위한 교육 과정 정보를 설정해주세요</p>
          </div>

          <div class="settings-compact">
            <div class="settings-row">
              <div class="setting-group">
                <label class="setting-label">부서</label>
                <div class="custom-select" :class="{ active: isDepartmentPopoverOpen }" role="combobox" :aria-expanded="isDepartmentPopoverOpen">
                  <button @click="isDepartmentPopoverOpen = !isDepartmentPopoverOpen" class="select-button" aria-haspopup="listbox">
                    <span class="select-value">{{ selectedCategory ? getCategoryLabel(selectedCategory) : "부서 선택" }}</span>
                    <svg class="select-arrow" :class="{ 'rotate-180': isDepartmentPopoverOpen }" width="12" height="8" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z" fill="currentColor" />
                    </svg>
                  </button>

                  <div v-if="isDepartmentPopoverOpen" class="select-dropdown">
                    <button @click="isDepartmentPopoverOpen = false" class="dropdown-close" aria-label="닫기">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                          fill="currentColor"
                        />
                      </svg>
                    </button>
                    <label
                      class="dropdown-option"
                      @click="
                        () => {
                          selectedCategory = '';
                          handleListChange();
                        }
                      "
                    >
                      <input type="radio" value="" v-model="selectedCategory" class="option-radio" />
                      선택 안 함
                    </label>
                    <label
                      v-for="category in groups"
                      :key="category.value"
                      class="dropdown-option"
                      @click="
                        () => {
                          selectedCategory = category.value;
                          handleListChange();
                        }
                      "
                    >
                      <input type="radio" :value="category.value" v-model="selectedCategory" class="option-radio" />
                      {{ category.label }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="setting-group">
                <label class="setting-label">학기/과정</label>
                <div class="custom-select" :class="{ active: isSemesterPopoverOpen }" role="combobox" :aria-expanded="isSemesterPopoverOpen">
                  <button @click="isSemesterPopoverOpen = !isSemesterPopoverOpen" class="select-button" aria-haspopup="listbox">
                    <span class="select-value">{{ selectedSemester ? getSemesterLabel(selectedSemester) : "학기/과정 선택" }}</span>
                    <svg class="select-arrow" :class="{ 'rotate-180': isSemesterPopoverOpen }" width="12" height="8" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z" fill="currentColor" />
                    </svg>
                  </button>

                  <div v-if="isSemesterPopoverOpen" class="select-dropdown">
                    <button @click="isSemesterPopoverOpen = false" class="dropdown-close" aria-label="닫기">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                          fill="black"
                        />
                      </svg>
                    </button>
                    <label
                      class="dropdown-option"
                      @click="
                        () => {
                          selectedSemester = '';
                          handleSemesterChange();
                        }
                      "
                    >
                      <input type="radio" value="" v-model="selectedSemester" class="option-radio" />
                      선택 안 함
                    </label>
                    <label
                      v-for="semester in semesters"
                      :key="semester.value"
                      class="dropdown-option"
                      @click="
                        () => {
                          selectedSemester = semester.value;
                          handleSemesterChange();
                        }
                      "
                    >
                      <input type="radio" :value="semester.value" v-model="selectedSemester" class="option-radio" />
                      {{ semester.label }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="setting-group">
                <label class="setting-label">과</label>
                <div class="custom-select" :class="{ active: isChapterPopoverOpen }" role="combobox" :aria-expanded="isChapterPopoverOpen">
                  <button @click="isChapterPopoverOpen = !isChapterPopoverOpen" class="select-button" aria-haspopup="listbox">
                    <span class="select-value">{{ selectedLesson ? getChapterLabel(selectedLesson) : "과 선택" }}</span>
                    <svg class="select-arrow" :class="{ 'rotate-180': isChapterPopoverOpen }" width="12" height="8" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z" fill="black" />
                    </svg>
                  </button>

                  <div v-if="isChapterPopoverOpen" class="select-dropdown">
                    <button @click="isChapterPopoverOpen = false" class="dropdown-close" aria-label="닫기">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                          fill="black"
                        />
                      </svg>
                    </button>

                    <label
                      class="dropdown-option"
                      @click="
                        () => {
                          selectedLesson = '';
                          handleListChange();
                        }
                      "
                    >
                      <input type="radio" value="" v-model="selectedLesson" class="option-radio" />
                      선택 안 함
                    </label>
                    <label
                      v-for="chapter in filteredLessons"
                      :key="chapter.value"
                      class="dropdown-option"
                      @click="
                        () => {
                          selectedLesson = chapter.value;
                          handleListChange();
                        }
                      "
                    >
                      <input type="radio" :value="chapter.value" v-model="selectedLesson" class="option-radio" />
                      {{ chapter.label }}
                    </label>
                  </div>
                </div>
              </div>

              <button v-if="$store.state.uid.id" class="save-button" @click="putPreference">
                <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14 3.11111V12.4444C14 12.8722 13.8478 13.2386 13.5434 13.5434C13.2391 13.8483 12.8727 14.0005 12.4444 14H1.55556C1.12778 14 0.761704 13.8478 0.457333 13.5434C0.152963 13.2391 0.000518519 12.8727 0 12.4444V1.55556C0 1.12778 0.152445 0.761704 0.457333 0.457333C0.762222 0.152963 1.1283 0.000518518 1.55556 0H10.8889L14 3.11111ZM7 11.6667C7.64815 11.6667 8.19907 11.4398 8.65278 10.9861C9.10648 10.5324 9.33333 9.98148 9.33333 9.33333C9.33333 8.68518 9.10648 8.13426 8.65278 7.68055C8.19907 7.22685 7.64815 7 7 7C6.35185 7 5.80093 7.22685 5.34722 7.68055C4.89352 8.13426 4.66667 8.68518 4.66667 9.33333C4.66667 9.98148 4.89352 10.5324 5.34722 10.9861C5.80093 11.4398 6.35185 11.6667 7 11.6667ZM2.33333 5.44444H9.33333V2.33333H2.33333V5.44444Z"
                    fill="currentColor"
                  />
                </svg>
                저장
              </button>
            </div>
          </div>
        </section>

        <!-- 최근 구매 콘텐츠 섹션 -->
        <section class="recent-content-section">
          <div class="section-header">
            <h2 class="section-title">최근 구매한 콘텐츠</h2>
            <router-link to="/mypage/contentsBox" class="view-all-link">
              전체보기
              <svg width="16" height="16" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.74999 15C6.74952 14.9015 6.76874 14.8038 6.80652 14.7128C6.8443 14.6218 6.89988 14.5392 6.96999 14.47L11.44 9.99999L6.99999 5.52999C6.9086 5.38904 6.86718 5.22148 6.88237 5.05418C6.89755 4.88687 6.96847 4.72951 7.08375 4.60731C7.19903 4.48512 7.35199 4.40516 7.51813 4.38026C7.68427 4.35536 7.85395 4.38696 7.99999 4.46999L13 9.47C13.1404 9.61062 13.2193 9.80124 13.2193 9.99999C13.2193 10.1987 13.1404 10.3894 13 10.53L7.99999 15.53C7.85936 15.6704 7.66874 15.7493 7.46999 15.7493C7.27124 15.7493 7.08061 15.6704 6.93999 15.53C6.8093 15.3853 6.74101 15.1948 6.74999 15Z"
                  fill="currentColor"
                />
              </svg>
            </router-link>
          </div>

          <div v-if="myContentsList.length" class="content-grid">
            <div v-for="content in myContentsList" :key="content.orderItemId" class="content-card">
              <div class="content-thumbnail">
                <img v-if="content.thumbnailLink" :src="'https://eduwind-api.nodeblack.net/' + content.thumbnailLink" :alt="content.orderItemTitle" />
                <img v-else :src="require('@/assets/img/null_img.jpg')" :alt="content.orderItemTitle" />
                <div :class="['content-type-badge', getContentTypeClass(content.contentType)]">
                  {{ getContentTypeLabel(content.contentType) }}
                </div>
              </div>
              <div class="content-info">
                <h3 class="content-title">{{ content.orderItemTitle }}</h3>
                <p class="content-meta">
                  <span class="purchase-date">{{ getPurchaseDateLabel(content) }}</span>
                  <span v-if="getExpirationLabel(content)" class="expiration-date" :class="{ expired: isExpired(content.downloadExpiration) }"> · {{ getExpirationLabel(content) }} </span>
                </p>
                <div class="content-actions">
                  <template v-if="content.contentType === 'VIDEO'">
                    <div v-if="content.orderVideoInfoList && content.orderVideoInfoList.length" class="video-action-group">
                      <div v-for="vid in content.orderVideoInfoList" :key="vid.orderVideoId" class="video-action-row">
                        <button
                          type="button"
                          class="action-link primary"
                          :class="{ 'is-disabled': !vid.linkNormal }"
                          :disabled="!vid.linkNormal"
                          @click.prevent="vid.linkNormal ? openVideoModal(vid.linkNormal) : null"
                        >
                          일반화질
                        </button>
                        <button
                          v-if="vid.linkHigh"
                          type="button"
                          class="action-link secondary"
                          :class="{ 'is-disabled': !vid.linkHigh }"
                          :disabled="!vid.linkHigh"
                          @click.prevent="vid.linkHigh ? openVideoModal(vid.linkHigh) : null"
                        >
                          고화질
                        </button>
                      </div>
                    </div>
                    <span v-else class="action-hint">영상 준비중</span>
                  </template>
                  <template v-else>
                    <div class="video-action-group">
                      <div class="video-action-row">
                        <button
                          v-if="content.orderDownloadInfoList && content.orderDownloadInfoList.length > 1"
                          type="button"
                          class="action-link primary"
                          :class="{ 'is-disabled': downloadingZips[content.orderItemId] }"
                          :disabled="downloadingZips[content.orderItemId]"
                          @click="downloadZIPContent(content.orderItemId)"
                        >
                          {{ downloadingZips[content.orderItemId] ? "다운로드 준비중..." : "모두 다운로드" }}
                        </button>
                        <button
                          v-else-if="content.orderDownloadInfoList && content.orderDownloadInfoList.length === 1"
                          type="button"
                          class="action-link primary"
                          :class="{ 'is-disabled': downloadingFiles[content.orderDownloadInfoList[0].orderDownloadId] }"
                          :disabled="downloadingFiles[content.orderDownloadInfoList[0].orderDownloadId]"
                          @click="downloadContent(content.orderDownloadInfoList[0].orderDownloadId, content.orderItemId)"
                        >
                          {{ downloadingFiles[content.orderDownloadInfoList[0].orderDownloadId] ? "다운로드 준비중..." : "다운로드" }}
                        </button>
                        <span v-else class="action-hint">다운로드 준비중</span>
                      </div>
                    </div>
                  </template>
                  <router-link v-if="content.orderItemId" :to="`/mypage/contentsBox/${content.orderItemId}`" class="action-link secondary"> 상세보기 </router-link>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state">최근 구매한 콘텐츠가 없습니다.</div>
        </section>
      </div>
    </div>

    <!-- 영상 모달 -->
    <div v-if="isDetailModalOpen" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black/60" @click="closeDetailModal"></div>
      <div class="relative z-10 w-full max-w-[70.5rem] mx-4 bg-white rounded-2xl shadow-xl overflow-hidden">
        <div class="flex items-center justify-end border-b border-neutral-200 md:p-4 p-2">
          <button type="button" class="text-neutral-400 hover:text-neutral-700" @click="closeDetailModal">
            <span class="sr-only">닫기</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.062 4.062a.875.875 0 0 1 1.237 0L10 8.763l4.701-4.701a.875.875 0 1 1 1.237 1.237L11.237 10l4.701 4.701a.875.875 0 0 1-1.237 1.237L10 11.237l-4.701 4.701a.875.875 0 1 1-1.237-1.237L8.763 10 4.062 5.299a.875.875 0 0 1 0-1.237Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        <div class="max-h-[70vh] overflow-y-auto">
          <div v-if="selectedContentDetail" class="space-y-6">
            <section v-for="(section, idx) in selectedContentDetail" :key="idx">
              <template v-if="section.videoLinkNormal">
                <iframe
                  v-if="getVideoInfo(section.videoLinkNormal).type === 'youtube'"
                  :src="getVideoInfo(section.videoLinkNormal).src"
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                  style="width: 100%; height: auto; aspect-ratio: 16 / 9"
                ></iframe>

                <div v-else-if="getVideoInfo(section.videoLinkNormal).type === 'vimeo'" style="width: 100%; height: auto; aspect-ratio: 16 / 9">
                  <iframe
                    :src="getVideoInfo(section.videoLinkNormal).src"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    style="width: 100%; height: 100%"
                    allowfullscreen
                  ></iframe>
                </div>

                <iframe v-else :src="section.videoLinkNormal" allowfullscreen style="width: 100%; height: auto; aspect-ratio: 16 / 9"></iframe>
              </template>
            </section>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import store from "@/store";
import router from "@/router";
import { VDialog } from "vuetensils/src/components";
import { ref, onMounted, onUnmounted, computed } from "vue";
import axios from "axios";

import MemberProfilePage from "@/pages/MemberProfilePage.vue";

const logout = () => {
  localStorage.removeItem("authorization");
  store.commit("setAccount", 0);
  store.commit("setLevel", 0);
  store.commit("setUid", "");
  router.push({ path: "/" });
};

// 모바일 메뉴 상태
const isMobileMenuOpen = ref(false);

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
  if (isMobileMenuOpen.value) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
};

// ESC 키로 모바일 메뉴 닫기
const handleKeyDown = (event) => {
  if (event.key === "Escape" && isMobileMenuOpen.value) {
    toggleMobileMenu();
  }
};

// 하나 바이블 설정 관련 로직
const isDepartmentPopoverOpen = ref(false);
const isSemesterPopoverOpen = ref(false);
const isChapterPopoverOpen = ref(false);

const selectedCategory = ref("");
const selectedSemester = ref("");
const selectedLesson = ref("");

const groups = [
  { label: "영유아부", value: "INFANT" },
  { label: "유치부", value: "KINDERGARTEN" },
  { label: "유년부", value: "CHILD" },
  { label: "초등부", value: "ELEMENTARY" },
  { label: "청소년", value: "TEENAGER" },
  { label: "대학 및 청년부", value: "ADULT" },
];

const semesters = [
  { label: "1과정1학기", value: "1-1", group: "1" },
  { label: "1과정2학기", value: "1-2", group: "2" },
  { label: "2과정1학기", value: "2-1", group: "1" },
  { label: "2과정2학기", value: "2-2", group: "2" },
  { label: "3과정1학기", value: "3-1", group: "1" },
  { label: "3과정2학기", value: "3-2", group: "2" },
  { label: "4과정1학기", value: "4-1", group: "1" },
  { label: "4과정2학기", value: "4-2", group: "2" },
  { label: "5과정1학기", value: "5-1", group: "1" },
  { label: "5과정2학기", value: "5-2", group: "2" },
  { label: "6과정1학기", value: "6-1", group: "1" },
  { label: "6과정2학기", value: "6-2", group: "2" },
];

const lessons = [
  { label: "1과", value: "1", group: "1" },
  { label: "2과", value: "2", group: "1" },
  { label: "3과", value: "3", group: "1" },
  { label: "4과", value: "4", group: "1" },
  { label: "5과", value: "5", group: "1" },
  { label: "6과", value: "6", group: "1" },
  { label: "7과", value: "7", group: "1" },
  { label: "8과", value: "8", group: "1" },
  { label: "9과", value: "9", group: "1" },
  { label: "10과", value: "10", group: "1" },
  { label: "11과", value: "11", group: "1" },
  { label: "12과", value: "12", group: "1" },
  { label: "13과", value: "13", group: "1" },
  { label: "14과", value: "14", group: "1" },
  { label: "15과", value: "15", group: "1" },
  { label: "16과", value: "16", group: "1" },
  { label: "17과", value: "17", group: "1" },
  { label: "18과", value: "18", group: "1" },
  { label: "19과", value: "19", group: "1" },
  { label: "20과", value: "20", group: "1" },
  { label: "21과", value: "21", group: "1" },
  { label: "22과", value: "22", group: "1" },

  { label: "23과", value: "23", group: "2" },
  { label: "24과", value: "24", group: "2" },
  { label: "25과", value: "25", group: "2" },
  { label: "26과", value: "26", group: "2" },
  { label: "27과", value: "27", group: "2" },
  { label: "28과", value: "28", group: "2" },
  { label: "29과", value: "29", group: "2" },
  { label: "30과", value: "30", group: "2" },
  { label: "31과", value: "31", group: "2" },
  { label: "32과", value: "32", group: "2" },
  { label: "33과", value: "33", group: "2" },
  { label: "34과", value: "34", group: "2" },
  { label: "35과", value: "35", group: "2" },
  { label: "36과", value: "36", group: "2" },
  { label: "37과", value: "37", group: "2" },
  { label: "38과", value: "38", group: "2" },
  { label: "39과", value: "39", group: "2" },
  { label: "40과", value: "40", group: "2" },
  { label: "41과", value: "41", group: "2" },
  { label: "42과", value: "42", group: "2" },
  { label: "43과", value: "43", group: "2" },
  { label: "44과", value: "44", group: "2" },

  { label: "어버이주일", value: "어버이주일", group: "3" },
  { label: "어린이주일", value: "어린이주일", group: "3" },
  { label: "부활주일", value: "부활주일", group: "3" },
  { label: "종려주일", value: "종려주일", group: "3" },
  { label: "성탄주일", value: "성탄주일", group: "3" },
  { label: "추수감사", value: "추수감사", group: "3" },
  { label: "전도선교", value: "전도선교", group: "3" },
  { label: "이단경계", value: "이단경계", group: "3" },
  { label: "이웃사랑", value: "이웃사랑", group: "3" },
  { label: "나라사랑", value: "나라사랑", group: "3" },
  { label: "공통", value: "공통", group: "3" },
];

const filteredLessons = computed(() => {
  const currentSemester = semesters.find((s) => s.value === selectedSemester.value);

  if (!currentSemester) {
    return lessons;
  }

  const group = currentSemester.group;

  if (group === "1") {
    return lessons.filter((l) => l.group === "1" || l.group === "3");
  } else if (group === "2") {
    return lessons.filter((l) => l.group === "2" || l.group === "3");
  } else if (group === "3") {
    return lessons.filter((l) => l.group === "3");
  }

  return lessons;
});

const getCategoryLabel = (value) => {
  const category = groups.find((c) => c.value === value);
  return category ? category.label : "";
};

const getSemesterLabel = (value) => {
  const semester = semesters.find((s) => s.value === value);
  return semester ? semester.label : "";
};

const getChapterLabel = (value) => {
  const chapter = lessons.find((c) => c.value === value);
  return chapter ? chapter.label : "";
};

const handleSemesterChange = () => {
  selectedLesson.value = "";
  handleListChange();
};

const handleListChange = () => {
  isDepartmentPopoverOpen.value = false;
  isSemesterPopoverOpen.value = false;
  isChapterPopoverOpen.value = false;
};

const putPreference = async () => {
  if (selectedCategory.value || selectedSemester.value || selectedLesson.value) {
    const preferenceValue = selectedCategory.value + ":" + selectedSemester.value + ":" + selectedLesson.value;

    try {
      axios
        .put("/new_api/account/hana-bible-preference", {
          hanaBiblePreference: preferenceValue,
        })
        .then(() => {
          alert("설정이 저장되었습니다.");
        });
    } catch (error) {
      console.error(error);
    }
  } else {
    alert("부서, 학기/과정, 과를 선택해 주세요.");
    return;
  }
};

const getPreference = async () => {
  try {
    const res = await axios.get(`/new_api/account/hana-bible-preference`);
    const rawPreference = res.data.data.hanaBiblePreference;

    if (rawPreference) {
      const parts = rawPreference.split(":");

      selectedCategory.value = parts[0] || "";
      selectedSemester.value = parts[1] || "";
      selectedLesson.value = parts[2] || "";
    }
  } catch (error) {
    console.error(error);
  }
};

const formatDateForApi = (date) => date.toISOString().split("T")[0];

const start = new Date();
const end = new Date();
start.setDate(end.getDate() - 14);

const range = ref({ start, end });

const formStartDate = computed(() => formatDateForApi(range.value.start));
const formEndDate = computed(() => formatDateForApi(range.value.end));

const myContentsList = ref([]);

const page = ref(1);
const size = ref(6);

const getMyContentsList = async (num) => {
  try {
    const pageValue = num !== undefined ? 1 : page.value;
    const { data } = await axios.get(`/new_api/customer/order/item/list?page=${pageValue}&size=${size.value}&startDate=${formStartDate.value}&endDate=${formEndDate.value}`);
    myContentsList.value = data.data.orderItemList || [];
  } catch (error) {
    console.error(error);
  }
};

// 콘텐츠 타입 레이블
const getContentTypeLabel = (type) => {
  const typeLabels = {
    FILE: "파일",
    VIDEO: "영상",
    MUSIC: "음원",
    IMAGE: "이미지",
  };
  return typeLabels[type] || type;
};

const getContentTypeClass = (type) => {
  const typeClasses = {
    FILE: "type-file",
    VIDEO: "type-video",
    MUSIC: "type-music",
    IMAGE: "type-image",
  };
  return typeClasses[type] || "type-default";
};

// 날짜 포맷팅
const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}.${month}.${day}`;
};

const getPurchaseDateValue = (item) => {
  return item?.orderDateTime || item?.orderDate || item?.purchaseDate || item?.createdAt || item?.orderCreatedAt || item?.orderItemDate || null;
};

const getPurchaseDateLabel = (item) => {
  const value = getPurchaseDateValue(item);
  return formatDate(value) || "구매일 정보 없음";
};

const base = new Date("2000-01-01");
const today = new Date();

const isExpired = (date) => {
  if (!date) return false;
  const expirationDate = new Date(date);
  return expirationDate < today;
};

const isUnlimited = (date) => {
  if (!date) return false;
  return new Date(date) < base;
};

const getExpirationLabel = (item) => {
  if (!item?.downloadExpiration) return "";
  if (isUnlimited(item.downloadExpiration)) return "무제한";
  const formatted = formatDate(item.downloadExpiration);
  if (!formatted) return "";
  return `${formatted} 까지${isExpired(item.downloadExpiration) ? " (기한만료)" : ""}`;
};

// [추가] 모달 관련 상태
const isDetailModalOpen = ref(false);
const selectedContentDetail = ref([]); // 모달에 전달할 영상 정보 배열

// [추가] 모달 열기 (URL 받아서 배열 형태로 변환)
const openVideoModal = (url) => {
  if (!url) return;
  selectedContentDetail.value = [{ videoLinkNormal: url }];
  isDetailModalOpen.value = true;
};

// [추가] 모달 닫기
const closeDetailModal = () => {
  isDetailModalOpen.value = false;
  selectedContentDetail.value = [];
};

// [추가] 영상 URL 파싱 및 타입 확인 함수
const getVideoInfo = (url) => {
  if (!url) return { type: null };

  const trimmed = url.trim();

  const vimeoMatch = trimmed.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
  if (vimeoMatch && vimeoMatch[1]) {
    return {
      type: "vimeo",
      id: vimeoMatch[1],
      src: `https://player.vimeo.com/video/${vimeoMatch[1]}`,
    };
  }

  const ytMatch = trimmed.match(/youtu\.be\/([^?&#]+)/i) ?? trimmed.match(/youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)([^?&#]+)/i) ?? trimmed.match(/[?&]v=([^?&#]+)/i);

  if (ytMatch && ytMatch[1]) {
    return {
      type: "youtube",
      id: ytMatch[1],
      src: `https://www.youtube.com/embed/${ytMatch[1]}`,
    };
  }

  return { type: null };
};

// [추가] 다운로드 상태 관리
const downloadingFiles = ref({});
const downloadingZips = ref({});

// 컨텐츠 개별 다운로드
const downloadContent = async (orderDownloadId, orderItemId) => {
  if (downloadingFiles.value[orderDownloadId]) return;
  downloadingFiles.value[orderDownloadId] = true;
  try {
    const res = await axios.get(`/new_api/customer/order/content/download/one?orderContentId=${orderItemId}&orderDownloadId=${orderDownloadId}`, {
      responseType: "blob",
    });

    const blob = new Blob([res.data], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);

    const downloadLink = Object.assign(document.createElement("a"), {
      href: url,
      download: decodeURIComponent(
        res.headers["content-disposition"]
          .match(/filename\*?=(UTF-8[''].*'')?([^;]+)/)[2]
          .trim()
          .replace(/^"=\?UTF-8\?Q\?/, "")
          .replace(/\?="$/, ""),
      ),
    });

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
  } finally {
    downloadingFiles.value[orderDownloadId] = false;
  }
};

// 컨텐츠 일괄 다운로드 (ZIP)
const downloadZIPContent = async (orderItemId) => {
  if (downloadingZips.value[orderItemId]) return;
  downloadingZips.value[orderItemId] = true;
  try {
    const res = await axios.get(`/new_api/customer/order/content/download/zip?orderContentId=${orderItemId}`, {
      responseType: "blob",
    });

    const blob = new Blob([res.data], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);

    const downloadLink = Object.assign(document.createElement("a"), {
      href: url,
      download: decodeURIComponent(
        res.headers["content-disposition"]
          .match(/filename\*?=(UTF-8[''].*'')?([^;]+)/)[2]
          .trim()
          .replace(/^"=\?UTF-8\?Q\?/, "")
          .replace(/\?="$/, ""),
      ),
    });

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
  } finally {
    downloadingZips.value[orderItemId] = false;
  }
};

onMounted(async () => {
  await getPreference();
  await getMyContentsList();
  document.addEventListener("keydown", handleKeyDown);

  if (!document.querySelector('script[src="https://player.vimeo.com/api/player.js"]')) {
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    document.head.appendChild(script);
  }
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeyDown);
  document.body.style.overflow = "";
});
</script>

<style scoped lang="scss">
/* ========================================
   Variables & Reset
   ======================================== */
.mypage-redesign {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 0;
  font-family: "Pretendard", "Malgun Gothic", sans-serif;
}

/* ========================================
   Header
   ======================================== */
.mypage-header {
  background: #ffffff;
  border-bottom: 1px solid #dee0e3;
  padding: 32px 0;
  margin-bottom: 40px;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.welcome-section {
  .page-title {
    font-size: 32px;
    font-weight: 700;
    color: #222;
    margin: 0 0 8px 0;
  }

  .welcome-text {
    font-size: 16px;
    color: #555961;
    margin: 0;

    .user-name {
      font-weight: 600;
      color: #0c3388;
    }
  }
}

.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.mobile-menu-button {
  display: none;
  padding: 8px;
  background: transparent;
  border: none;
  color: #555961;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #0c3388;
  }

  @media (max-width: 767px) {
    display: flex;
  }
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  &.primary {
    background: #0c3388;
    color: #ffffff;

    &:hover {
      background: #092968;
    }
  }

  &.secondary {
    background: #ffffff;
    color: #555961;
    border: 1px solid #dee0e3;

    &:hover {
      background: #f5f5f5;
      border-color: #0c3388;
      color: #0c3388;
    }
  }

  @media (max-width: 767px) {
    display: none;

    &.primary {
      display: flex;
    }
  }
}

/* ========================================
   Mobile Menu
   ======================================== */
.mobile-menu-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.mobile-sidebar {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100%;
  background: #ffffff;
  z-index: 1001;
  overflow-y: auto;
  animation: slideInLeft 0.3s ease-out;
  box-shadow: 4px 0 12px rgba(0, 0, 0, 0.1);
}

.mobile-sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #dee0e3;
}

.mobile-sidebar-title {
  font-size: 20px;
  font-weight: 700;
  color: #222;
  margin: 0;
}

.mobile-sidebar-close {
  padding: 8px;
  background: transparent;
  border: none;
  color: #555961;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #0c3388;
  }
}

/* ========================================
   Main Container
   ======================================== */
.mypage-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px 80px;
  display: grid;
  grid-template-columns: 230px 1fr;
  gap: 40px;

  @media (max-width: 1023px) {
    grid-template-columns: 240px 1fr;
    gap: 32px;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    padding: 0 16px 40px;
  }
}

/* ========================================
   Sidebar Navigation
   ======================================== */
.sidebar-nav {
  position: sticky;
  top: 80px;
  height: fit-content;
  background: #ffffff;
  border: 1px solid #dee0e3;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  @media (max-width: 767px) {
    display: none;
  }
}

.nav-section {
  & + .nav-section {
    margin-top: 32px;
    padding-top: 32px;
    border-top: 1px solid #f0f0f0;
  }
}

.nav-title {
  font-size: 14px;
  font-weight: 700;
  color: #222;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  color: #555961;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s;
  white-space: nowrap;

  .nav-icon {
    font-size: 18px;
    flex-shrink: 0;
  }

  .nav-text {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .external-link-icon {
    flex-shrink: 0;
    opacity: 0.7;
    transition: opacity 0.2s;
  }

  &:hover {
    background: #f5f7fa;
    color: #0c3388;

    .external-link-icon {
      opacity: 1;
    }
  }

  &.router-link-active {
    background: #e8eef8;
    color: #0c3388;
    font-weight: 600;

    .external-link-icon {
      opacity: 1;
    }
  }
}

/* ========================================
   Main Content
   ======================================== */
.main-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* ========================================
   Section Common Styles
   ======================================== */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #222;
  margin: 0;

  @media (max-width: 767px) {
    font-size: 20px;
  }
}

.section-description {
  font-size: 14px;
  color: #888;
  margin: 8px 0 0 0;
}

.view-all-link {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #0c3388;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: gap 0.2s;

  &:hover {
    gap: 8px;
  }
}

/* ========================================
   Bible Settings Section
   ======================================== */
.bible-settings-section {
  background: #ffffff;
  border: 1px solid #dee0e3;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  @media (max-width: 767px) {
    padding: 24px 16px;
  }
}

.settings-compact {
  .settings-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr) auto;
    gap: 16px;
    align-items: end;

    @media (max-width: 1023px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;

      .save-button {
        grid-column: 1 / -1;
      }
    }

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
    }
  }
}

.setting-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.setting-label {
  font-size: 14px;
  font-weight: 600;
  color: #222;
}

.custom-select {
  position: relative;
  width: 100%;

  .select-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #ffffff;
    border: 1px solid #dee0e3;
    border-radius: 8px;
    font-size: 14px;
    color: #555961;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: #0c3388;
    }

    &:focus-visible {
      outline: 2px solid #0c3388;
      outline-offset: 2px;
    }
  }

  &.active .select-button {
    border-color: #0c3388;
  }

  .select-value {
    flex: 1;
    text-align: left;
  }

  .select-arrow {
    transition: transform 0.2s;

    &.rotate-180 {
      transform: rotate(180deg);
    }
  }

  .select-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: #ffffff;
    border: 1px solid #dee0e3;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    max-height: 300px;
    overflow-y: auto;
    z-index: 100;
    animation: slideDown 0.2s ease-out;
  }

  .dropdown-close {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 8px;
    background: transparent;
    border: none;
    color: #555961;
    cursor: pointer;
    transition: color 0.2s;
    z-index: 10;

    &:hover {
      color: #0c3388;
    }
  }

  .dropdown-option {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    font-size: 14px;
    color: #555961;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #f5f7fa;
    }

    .option-radio {
      cursor: pointer;
    }
  }
}

.save-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: #0c3388;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #092968;
  }

  &:focus-visible {
    outline: 2px solid #0c3388;
    outline-offset: 2px;
  }
}

/* ========================================
   Recent Content Section
   ======================================== */
.recent-content-section {
  background: #ffffff;
  border: 1px solid #dee0e3;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  @media (max-width: 767px) {
    padding: 24px 16px;
  }
}

.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
}

.content-card {
  background: #ffffff;
  border: 1px solid #dee0e3;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s;
  cursor: default;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
}

.content-thumbnail {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #f5f5f5;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .content-type-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    padding: 4px 12px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    border-radius: 16px;
    backdrop-filter: blur(4px);

    &.type-file {
      background: rgba(15, 118, 110, 0.92);
    }

    &.type-video {
      background: rgba(37, 99, 235, 0.92);
    }

    &.type-music {
      background: rgba(124, 58, 237, 0.92);
    }

    &.type-image {
      background: rgba(234, 88, 12, 0.92);
    }

    &.type-default {
      background: rgba(12, 51, 136, 0.9);
    }
  }
}

.content-info {
  padding: 20px;
}

.content-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.content-meta {
  font-size: 14px;
  color: #888;
  margin: 0 0 16px 0;

  .purchase-date {
    font-size: 12px;
  }

  .expiration-date {
    font-size: 12px;
    color: #666;
  }

  .expiration-date.expired {
    color: #e11d48;
  }
}

.content-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.action-link {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s;
  border: 1px solid transparent;
  cursor: pointer;

  &.primary {
    background: #0c3388;
    color: #ffffff;

    &:hover {
      background: #092968;
    }
  }

  &.secondary {
    background: #ffffff;
    color: #0c3388;
    border-color: #d2d6dc;

    &:hover {
      background: #f7f7f8;
    }
  }

  &.is-disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.video-action-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.video-action-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.action-hint {
  font-size: 12px;
  color: #9ca3af;
}

.empty-state {
  padding: 32px 0;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
}

/* ========================================
   Animations
   ======================================== */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

/* ========================================
   Focus Styles
   ======================================== */
*:focus-visible {
  outline: 2px solid #0c3388;
  outline-offset: 2px;
}
</style>
